module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Medium.woff
// module id = 680
// module chunks = 0